export const iconFontAwesomeUsersPeopleUserGraduate = (
	<i className="fa-solid fa-user-graduate"></i>
);
